
// ─────────────────────────────────────────────
// components/CareInfoSection.tsx
// ─────────────────────────────────────────────
import React from 'react';

export const CareInfoSection: React.FC<{ data: any }> = ({ data }) => (
    <section className="bg-white">
        <div className="inner-box">
            <h3 className="cont-tit"><span className="underline">돌봄요청 정보</span></h3>
            <div className="round-box mt10">
                <div className="round-body">
                    <div className="info-row">
                        <span className="label">돌봄 시작일</span>
                        <span className="cont">{data.careStartDate}</span>
                    </div>
                    <div className="info-row">
                        <span className="label">돌봄 종료일</span>
                        <span className="cont">{data.careEndDate}</span>
                    </div>
                    {data.workTypeName !== '종일제' && (
                        <>
                            <div className="info-row">
                                <span className="label">돌봄 시작시간</span>
                                <span className="cont">{data.workStartTime}</span>
                            </div>
                            <div className="info-row">
                                <span className="label">돌봄 종료시간</span>
                                <span className="cont">{data.workEndTime}</span>
                            </div>
                        </>
                    )}
                    <div className="info-row">
                        <span className="label">총 돌봄기간</span>
                        <span className="cont">총 {data.totalDays}일{data.workTypeName !== '종일제' && ` (매일 ${data.dailyHours}시간)`}</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
);
